import React from 'react'
import { Button, Space } from 'antd'
import styled from 'styled-components'
import useVersionCheck from '@lib/hooks/useVersionCheck'
import env from '@/env'

type FallbackComponentProps = {
  resetErrorBoundary: any
  error: Error
}

const ErrorFallback = ({ resetErrorBoundary, error }: FallbackComponentProps) => {
  const versionInfo = useVersionCheck()

  const handleReload = () => {
    window.location.reload()
  }

  React.useEffect(() => {
    console.log('[ErrorFallback][error?.message]:', error?.message || error?.toString() || '')
    console.log('[ErrorFallback][詳細]:', error)
    if (versionInfo) {
      console.log('[ErrorFallback][版本詳細錯誤訊息]:', versionInfo.currentVersion?.version)
    }
  }, [error, versionInfo])

  return (
    <ErrorFallbackWrapper>
      <ErrorContainer>
        <ErrorIcon />
        {versionInfo?.isNewVersion ? (
          <>
            <ErrorTitle>資料載入中斷</ErrorTitle>
            <ErrorMessage>Data Loading Interrupted</ErrorMessage>
            <ErrorDetail>為了確保資料準確性，請嘗試重新載入頁面。</ErrorDetail>
          </>
        ) : (
          <>
            <ErrorTitle>異常錯誤</ErrorTitle>
            <ErrorMessage>An error occurred</ErrorMessage>
            <ErrorDetail>請點選「重試」按鈕。</ErrorDetail>
          </>
        )}
        <Space size={[56, 24]}>
          <Button type="primary" onClick={handleReload}>
            {versionInfo?.isNewVersion ? '重新整理頁面 (Refresh Page)' : '重試 (Retry)'}
          </Button>
        </Space>
      </ErrorContainer>
    </ErrorFallbackWrapper>
  )
}

const ErrorFallbackWrapper = styled.div`
  width: 100%;
  height: 100vh;
  margin: 50px auto;
  padding: 50px;
  display: flex;
  justify-content: center;
  background: #f5f5f5;
`

const ErrorContainer = styled.div`
  max-width: 600px;
  height: 460px;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 48px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
`

const ErrorIcon = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto 24px;
  background-image: url('${env.publicUrl}/img/404.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`

const ErrorTitle = styled.h1`
  margin: 0 0 16px;
  color: #434e59;
  font-weight: 600;
  font-size: 32px;
  line-height: 1.2;
`

const ErrorMessage = styled.div`
  margin-bottom: 24px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 16px;
  line-height: 1.5;
`

const ErrorDetail = styled.div`
  margin-bottom: 32px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
  text-align: left;
  font-size: 14px;
  color: #e17567;
  word-break: break-word;
  max-height: 200px;
  overflow-y: auto;
`

export default ErrorFallback
